/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { push } from '@lagunovsky/redux-react-router';
import * as React from 'react';
import { Route, Routes } from 'react-router';
import Footer from '../../components/Footer';
import { ActionForwardComponent } from '../../components/Highscores';
import { CacheStatisticsScreen } from '../../components/SysAdminApp/CacheStatisticsComponent';
import { EventHandlerConfigScreen } from '../../components/SysAdminApp/EventHandlerConfig';
import { SqlStatisticsScreen, sysAdminSqlPath } from '../../components/SysAdminApp/SQLStatisticsComponent';
import { sysAdminUseCaseLogPath, UseCaseLogScreen } from '../../components/SysAdminApp/UseCaseLogs';
import { WebUsageScreen } from '../../components/SysAdminApp/WebUsage';
import { JobScreen, sysAdminJobPath } from './JobScreen';
import { SystemProperties } from './SystemProperties';

export const SysAdmin: React.FC<{}> = () => {
    return (
        <>
            <Routes>
                <Route path="jobs/:serverName" element={<JobScreen />} />
                <Route path="jobs/*" element={<ActionForwardComponent action={push(sysAdminJobPath('betting'))} /> } />
                <Route path="sql/:serverName" element={<SqlStatisticsScreen />} />
                <Route path="sql/*" element={<ActionForwardComponent action={push(sysAdminSqlPath('betting'))} />} />
                <Route path="cache/:serverName?" element={<CacheStatisticsScreen />} />
                <Route path="usage/:serverName?" element={<WebUsageScreen />} />
                <Route path="ucl/:serverName" element={<UseCaseLogScreen />} />
                <Route path="ucl/*" element={<ActionForwardComponent action={push(sysAdminUseCaseLogPath('betting'))} />} />
                <Route path="properties" element={<SystemProperties />} />
                <Route path="event-handler/:serverName?" element={<EventHandlerConfigScreen />} />
                <Route path="/" element={<SqlStatisticsScreen />} />
            </Routes>
            <Footer />
        </>
    );
};
